import { Title } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHomeVM } from './useHomeVm';

const Home: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const { isError } = useHomeVM();

    if (isError) {
        return <Title text={'qr_code_error'} type="large" />;
    }
    return (
        <>
            <h1 style={{ color: 'var(--color-text-main)', fontFamily: 'var(--font-family-text)' }}>
                {t('home')} : var(--color-text-main)
            </h1>
            <div style={{ color: 'var(--color-text-secondary)' }}>
                Text : var(--color-text-secondary)
            </div>
        </>
    );
};

export default Home;
